import React, { useState } from "react";
import leftArrow from "../../assets/leftArrow.svg";
import verifyImg from "../../assets/verify.png";
import heartIcon from "../../assets/heartIcon.svg";
import Layout from "../../shared/Layout/Layout";
import Main from "../../containers/_item_details/Main/Main";
import NewestCollection from "../../components/_home/NewestCollection/NewestCollection";
import { newest } from "../../mock/newest";
import Buy from "../../shared/Modals/Buy/Buy";
import Owner from "../../shared/Modals/Owner/Owner";
import Transfer from "../../shared/Modals/Transfer/Transfer";
import styles from "./ItemDetails.module.scss";

const ItemDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.details}>
            {/* HEADER */}
            <div className={styles.header}>
              <div className={styles.leftArrow}>
                <img src={leftArrow} alt="go-back" />
              </div>
              <div className={styles.name}>
                <h2>Cryptographics #1267</h2>
                <small>
                  By Cryptographics <img src={verifyImg} alt="verified" />
                </small>
              </div>
              <div className={styles.likes}>
                <img src={heartIcon} alt="likes" />
                12
              </div>
            </div>

            {/* MAIN */}
            <Main
              setIsModalOpen={setIsModalOpen}
              setIsModalOpen3={setIsModalOpen3}
            />
          </div>

          <div className={styles.more}>
            <h2>More from this collection</h2>
            <div className={styles.cards}>
              {newest.map((i) => (
                <NewestCollection
                  key={i.id}
                  name={i.name}
                  creator={i.creator}
                  media={i.media}
                  type={i.type}
                  price={i.price}
                  likes={i.likes}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Buy
          setIsModalOpen={setIsModalOpen}
          setIsModalOpen2={setIsModalOpen2}
        />
      )}
      {isModalOpen2 && <Owner setIsModalOpen={setIsModalOpen2} />}
      {isModalOpen3 && <Transfer setIsModalOpen={setIsModalOpen3} />}
    </Layout>
  );
};

export default ItemDetails;
